<template>
  <div class="white-bg" v-if="act">
    <div id="reg_page_body" class="page-body">
      <nav
        v-if="actTitle"
        id="actTitleNavbar"
        class="navbar navbar-default"
        style="margin-bottom:0;"
      >
        <div>
          <div id="actTitleHeader" class="navbar-header">
            <div
              class="navbar-text"
              id="actTitle"
              style="display: flex; justify-content: center; align-items: center; text-align: center;"
            >
              <button
                type="button"
                class="navbar-toggle pull-left expand-tabs-sm"
                style="margin-left: 8px;"
                data-toggle="collapse"
                data-target="#navbar-header-collapse"
                ng-click="resizeElements()"
              >
                <span class="fa fa-bars"></span>
              </button>
              {{ regViewActBean.actView.title }}
            </div>
          </div>
          <div class="row no-gutters w-100 nav-buttons-act">
            <div
              class="col-lg-offset-2 col-xl-8 col-md-offset-0 col-lg-10 col-sm-offset-0 col-xs-offset-0 col-sm-12 col-xs-12"
            >
              <ul
                class="nav navbar-nav hidden-small-collapse"
                style="clear:both; padding: 4px;"
              >
                <li
                  v-for="(item, index) in regViewActBean.actView.tabs"
                  v-bind:key="index"
                  class="tab-right-border"
                >
                  <div>
                    <a
                      rel="nofollow"
                      :href="`/${tabCodes[item.code].path}?q=${searchQuery}`"
                      target="_blank"
                      >{{ item.name }}</a
                    >
                  </div>
                </li>
              </ul>
              <div
                class="collapse"
                style="overflow-x: hidden; padding-left: 0px; padding-right: 0px;"
                id="navbar-header-collapse"
              >
                <ul
                  class="nav navbar-nav"
                  style="clear:both; padding: 4px; display: block;"
                >
                  <li
                    v-for="(item, index) in regViewActBean.actView.tabs"
                    v-bind:key="index"
                    class="tab-right-border"
                  >
                    <div>
                      <a
                        rel="nofollow"
                        :href="`/${tabCodes[item.code].path}?q=${searchQuery}`"
                        target="_blank"
                        >{{ item.name }}</a
                      >
                    </div>
                  </li>
                </ul>
                <ul
                  class="nav navbar-nav hidden-lg hidden-md"
                  style="clear:both; margin: 8px;"
                >
                  <li v-if="act != null && contentPrimaryLink != null">
                    <a @click="openActIdCard()">О акту</a>
                  </li>
                  <li v-if="implementsActNavigation && !wpp">
                    <a @click="openActNavigation()">Структура прописа</a>
                  </li>
                  <li v-if="!wpp && showGroupActs">
                    <a @click="openGroupActs()">Подзаконски акти</a>
                  </li>
                  <li
                    class="dropdown"
                    v-if="act.previousVersions.length > 0 && !wpp"
                    style="width: 100%;"
                  >
                    <a
                      class="dropdown-toggle"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Верзије пречишћеног текста
                    </a>
                    <ul class="dropdown-menu navigation-menu">
                      <li v-for="link in act.previousVersions" :key="link.url">
                        <a
                          @click="openPreviousVersion(link.url, link.regId)"
                          style="cursor: pointer!important;"
                          >{{ link.name }}</a
                        >
                      </li>
                    </ul>
                  </li>
                  <div
                    v-if="references && Object.keys(references).length !== 0"
                    style="width: 100%;"
                  >
                    <li class="dropdown">
                      <a
                        class="dropdown-toggle"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Референце
                      </a>
                      <ul
                        class="dropdown-menu navigation-menu"
                        aria-labelledby="dropdownMenu1"
                      >
                        <div v-for="item in filteredReferences" :key="item">
                          <div class="reference-list">
                            <h5>
                              <span class="fa fa-plus-square"></span>
                              {{ references[item].actReferenceTypeName }}
                            </h5>
                            <ul>
                              <div
                                v-for="act in references[item].lawActs"
                                :key="act.url"
                              >
                                <div v-if="act.inlineUrl === null">
                                  <li>
                                    <a target="_blank" :href="act.url">{{
                                      act.name
                                    }}</a>
                                  </li>
                                </div>
                                <div v-else-if="act.inlineUrl !== null">
                                  <li>
                                    <a
                                      @click="openInlineUrl(act.inlineUrl)"
                                      close-toolbar=""
                                      >{{ act.name }}</a
                                    >
                                  </li>
                                </div>
                              </div>
                            </ul>
                          </div>
                        </div>
                      </ul>
                    </li>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div class="row theme-green main-panel">
        <div class="flex-div">
          <div
            :class="{
              'col-lg-offset-2 col-xl-8 col-md-offset-0 col-lg-10 col-sm-offset-0 col-xs-offset-0 col-sm-12 col-xs-12':
                contentSecondary === null &&
                contentSecondaryLink === null &&
                relatedActsView === null,
              'col-lg-5 col-md-5 hidden-xs hidden-sm':
                contentSecondary !== null ||
                contentSecondaryLink !== null ||
                relatedActsView !== null,
            }"
            style="height: 100%; padding: 0;"
          >
            <div id="searchBarPrimary">
              <div class="input-group">
                <span class="input-group- left-search">
                  <button
                    class="btn btn-default"
                    type="button"
                    @click="onPrintClick"
                    title="Штампа"
                  >
                    <span class="fa fa-print"></span>
                  </button>
                  <button
                    v-if="!wpp"
                    class="btn btn-default"
                    type="button"
                    @click="onDocxExportClick"
                    title="Експорт у WORD"
                  >
                    <span class="fa fa-file-word"></span>
                  </button>
                  <button
                    v-if="!wpp"
                    class="btn btn-default"
                    type="button"
                    @click="onOnlyActContentClick"
                    title="Отвори само текст акта"
                  >
                    <span class="fa fa-external-link"></span>
                  </button>
                  <button
                    v-if="implementsShowChanges === true"
                    class="btn btn-default"
                    type="button"
                    @click="toggleShowChanges"
                    title="Прикажи текст са/без посебно назначених измена и допуна"
                  >
                    <span
                      class="fa"
                      :class="{
                        'fa-eye': showChanges === false,
                        'fa-eye-slash': showChanges === true,
                      }"
                    ></span>
                  </button>
                  <button
                    class="btn btn-default"
                    type="button"
                    @click="onPreviousClick"
                    title="Претходни резултат"
                  >
                    <span class="fa fa-chevron-left"></span>
                  </button>
                </span>
                <input
                  @keyup="primaryKeyUp"
                  v-model="textSearch"
                  type="text"
                  class="form-control"
                  placeholder="Претрага по приказаном тексту"
                />
                <span class="input-group-btn right-search" @click="onNextClick">
                  <button
                    class="last-btn btn btn-default"
                    type="button"
                    title="Следећи резултат"
                  >
                    <span class="fa fa-chevron-right"></span>
                  </button>
                </span>
              </div>
            </div>
            <div
              id="actContentPrimaryScroll"
              class="view-act-primary card card-1"
              :class="{
                'full-height':
                  act.actAbstract === null || act.actAbstract.length <= 0,
              }"
              style="overflow-y: auto; position: absolute; top: 35px;"
              @click="handleArticleClick"
            >
              <HtmlDiv
                :showChanges="showChanges"
                id="primaryContentHtml"
                v-html="contentPrimary"
                width="100%"
                height="800px"
                style="color: #333 !important"
              >
              </HtmlDiv>
            </div>
          </div>

          <div
            v-if="
              contentSecondaryLink !== null ||
                contentSecondary !== null ||
                relatedActsView !== null
            "
            :class="{ 'col-lg-5 col-md-12': true }"
            class="secondary-frame-parent"
            style="height: 100%;"
          >
            <div
              class="input-group"
              v-if="secondaryType !== 'relatedPdfActLink'"
            >
              <span class=" input-group-btn left-search">
                <button
                  class="btn btn-default"
                  type="button"
                  @click="closeSecondary"
                  title="Затвори панел"
                >
                  <span class="fa fa-times"></span>
                </button>
                <button
                  class="btn btn-default"
                  type="button"
                  @click="onPrintSecondaryClick"
                  title="Штампа"
                >
                  <span class="fa fa-print"></span>
                </button>
                <button
                  v-if="secondaryType === 'actIdCard'"
                  class="btn btn-default"
                  type="button"
                  @click="exportSecondary"
                  title="Експорт у WORD"
                >
                  <span class="fa fa-file-word"></span>
                </button>
              </span>
              <span
                class="input-group-btn previous-solo-btn"
                :class="{
                  hide:
                    secondaryType === 'groupActs' ||
                    secondaryType === 'actIdCard',
                }"
              >
                <button
                  class="btn btn-default"
                  type="button"
                  @click="onPreviousClickSecondary"
                  title="Претходни резултат"
                >
                  <span class="fa fa-chevron-left"></span>
                </button>
              </span>
              <input
                @keyup="secondaryKeyUp"
                v-model="textSearchSecondary"
                :class="{
                  hide:
                    secondaryType === 'groupActs' ||
                    secondaryType === 'actIdCard',
                }"
                type="text"
                class="form-control"
                placeholder="Претрага по приказаном тексту"
              />
              <span
                class="input-group-btn right-search"
                :class="{
                  hide:
                    secondaryType === 'groupActs' ||
                    secondaryType === 'actIdCard',
                }"
              >
                <button
                  class="last-btn btn btn-default"
                  type="button"
                  @click="onNextClickSecondary"
                  title="Следећи резултат"
                >
                  <span class="fa fa-chevron-right"></span>
                </button>
              </span>
            </div>
            <div class="input-group" v-else>
              <span class=" input-group-btn left-search">
                <button
                  class="btn btn-default"
                  type="button"
                  @click="closeSecondary"
                  title="Затвори панел"
                >
                  <span class="fa fa-times"></span>
                </button>
              </span>
            </div>
            <div class="table-panel1">
              <div
                id="actContentSecondaryScroll"
                :style="{
                  overflow:
                    secondaryType === 'groupActs' ||
                    secondaryType === 'actIdCard'
                      ? 'scroll'
                      : 'scroll',
                }"
                class="view-act-secondary card-1"
                v-if="
                  contentSecondaryLink !== null ||
                    contentSecondary !== null ||
                    relatedActsView !== null
                "
                @click="handleArticleClick"
              >
                <HtmlDiv
                  v-if="
                    relatedActsView == null &&
                      secondaryType !== 'relatedPdfActLink'
                  "
                  :showChanges="true"
                  id="actContentSecondary"
                  v-html="contentSecondary"
                  :class="{ 'state-menu': secondaryType === 'actNavigation' }"
                  width="100%"
                  height="100%"
                  style="font-size: 0.80rem;"
                ></HtmlDiv>
                <PDFJSViewer
                  v-else-if="
                    relatedActsView == null &&
                      secondaryType === 'relatedPdfActLink' &&
                      contentSecondary
                  "
                  style="height: calc(100vh - 300px) !important;"
                  id="actContentSecondary"
                  :srcUrl="contentSecondary"
                >
                </PDFJSViewer>
                <RelatedActsView
                  v-if="relatedActsView != null"
                  :related-acts-view="relatedActsView"
                  id="actContentSecondary"
                  @act-click="handleRelatedActClick"
                >
                </RelatedActsView>
              </div>
            </div>
          </div>

          <div class="col-lg-2 col-md-2 right-panel hidden-xs hidden-sm">
            <div
              class="panel-group"
              id="accordion"
              v-if="act != null && contentPrimaryLink != null"
            >
              <div
                @click="openActIdCard"
                class="panel panel-default "
                id="panelActIdCard"
                v-if="!wpp && act.sid === true"
              >
                <div class="panel-heading">
                  <h5 class="panel-title panel-title">
                    <a>
                      О акту
                    </a>
                  </h5>
                </div>
              </div>
              <div
                @click="openActNavigation"
                class="panel panel-default"
                id="panelActNavigation"
                v-if="implementsActNavigation === true && !wpp"
              >
                <div class="panel-heading">
                  <h5 class="panel-title">
                    <a>
                      Структура прописа
                    </a>
                  </h5>
                </div>
              </div>
              <div
                @click="openGroupActs"
                class="panel panel-default"
                id="panelGroupActs"
                v-if="!wpp && showGroupActs === true"
              >
                <div class="panel-heading">
                  <h5 class="panel-title">
                    <a>
                      Подзаконски акти
                    </a>
                  </h5>
                </div>
              </div>
              <div
                class="panel panel-default"
                id="panelAttachments"
                v-if="act.attachments.length > 0"
              >
                <div
                  data-toggle="collapse"
                  data-target="#collapseAttachments"
                  class="panel-heading"
                >
                  <h5 class="panel-title">
                    <a>
                      Прилози
                    </a>
                  </h5>
                </div>
                <div id="collapseAttachments" class="panel-collapse collapse">
                  <ul
                    class="panel-body list-group"
                    style="padding: 0px!important;"
                  >
                    <li
                      class="list-group-item"
                      v-for="link in act.attachments"
                      :key="link.name"
                    >
                      <a
                        rel="nofollow"
                        :href="
                          baseRegulationsApiUrl +
                            'prilozi/' +
                            link.name +
                            '?regulationsActId=' +
                            act.id +
                            '&docType=reg&removelinks=true'
                        "
                        target="_blank"
                        v-text="link.name"
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                class="panel panel-default"
                id="panelPreviousVersions"
                v-if="act.previousVersions.length > 0 && !wpp"
              >
                <div
                  data-toggle="collapse"
                  data-target="#collapsePreviousVersions"
                  class="panel-heading"
                >
                  <h5 class="panel-title">
                    <a>
                      Верзије пречишћеног текста
                    </a>
                  </h5>
                </div>
                <div
                  id="collapsePreviousVersions"
                  class="panel-collapse collapse"
                  ng-if="!wpp"
                >
                  <ul
                    class="panel-body list-group"
                    style="padding: 0px!important;"
                  >
                    <li
                      class="list-group-item"
                      v-for="link in act.previousVersions"
                      :key="link.url"
                    >
                      <a
                        @click="openPreviousVersion(link.url, link.regId)"
                        style="cursor: pointer!important;"
                        >{{ link.name }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div
                v-if="references && Object.keys(references).length !== 0"
                class="panel panel-default"
                id="panelReferences"
              >
                <div
                  data-toggle="collapse"
                  data-target="#collapseReferences"
                  class="panel-heading"
                >
                  <h5 class="panel-title">
                    <a>
                      Референце
                    </a>
                  </h5>
                </div>
                <div id="collapseReferences" class="panel-collapse collapse">
                  <ul
                    class="panel-body list-group"
                    style="padding: 0px!important;"
                  >
                    <div
                      v-for="key in filteredReferences"
                      :key="key"
                      class="reference-list"
                    >
                      <h5>
                        <span class="fa fa-plus-square"></span>
                        {{ references[key].actReferenceTypeName }}
                      </h5>
                      <ul>
                        <li
                          v-for="act in references[key].lawActs"
                          :key="act.url"
                        >
                          <a
                            v-if="act.inlineUrl === null"
                            :href="act.url"
                            target="_blank"
                            >{{ act.name }}</a
                          >
                          <a v-else @click="openInlineUrl(act.inlineUrl)">{{
                            act.name
                          }}</a>
                        </li>
                      </ul>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import axios from "axios";
import { mapState } from "vuex";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "jquery-highlight/jquery.highlight.js";
import HtmlDiv from "@/components/HtmlDiv.vue";
import RelatedActsView from "../reg/RelatedActsView.vue";

import { customAxios } from "@/utils/custom-axios";
import tabs from "@/utils/reg-related-act-tabs";
import PDFJSViewer from "@/components/PDFJSViewer.vue";

export default {
  name: "REGULATIONS_ViewActPage",
  props: ["doLoadComponent"],
  data() {
    return {
      baseRegulationsApiUrl: window.env.VUE_APP_API_REGULATIONS_DEV,
      baseDIApiUrl: window.env.VUE_APP_API_DI_DEV,
      contentPrimary: null,
      contentSecondary: null,
      contentSecondaryLink: null,
      secondaryType: "",
      relatedActsView: null,
      references: null,
      showChanges: true,
      showGroupActs: false,
      implementsActNavigation: false,
      textSearchSecondary: null,
      act: null,
      showSecondary: null,
      implementsShowChanges: false,
      scrollIndex: 0,
      scrollIndexSecondary: 0,
      textSearch: "",
      originalNavigationElements: [],
      navigationElements: [],
      metadataLinks: [],
      actTitle: "",
      versionGuid: "",
      actGuid: "",
      searchQuery: "",
      tabCodes: tabs,
    };
  },
  metaInfo() {
    const actTitle = this.actTitle;
    var filteredMetadata = this.metadataLinks.map((x) => {
      var arr = Object.entries(x);
      return Object.fromEntries(arr.filter((el) => el[1] !== null));
    });
    return {
      title: actTitle,
      meta: [
        { name: "google", content: "notranslate" },
        {
          name: "viewport",
          content:
            "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no",
        },
        { name: "robots", content: "index,nofollow,noarchive" },
        ...filteredMetadata,
      ],
    };
  },
  watch: {
    contentSecondaryLink(newValue) {
      if (newValue !== null) {
        this.relatedActsView = null;
        this.contentSecondary = null;
        let link =
          this.secondaryType === "fullLink" ||
          this.secondaryType === "actIdCard" ||
          this.secondaryType === "slglLink" ||
          this.secondaryType === "relatedHtmlActLink" ||
          this.secondaryType === "relatedPdfActLink"
            ? newValue
            : this.baseRegulationsApiUrl + newValue;
        customAxios(this.secondaryType === "relatedPdfActLink" ? "blob" : "")
          .get(link)
          .then((response) => {
            if (this.secondaryType === "relatedPdfActLink") {
              const file = new Blob([response.data], {
                type: "application/pdf",
              });
              const fileurl = URL.createObjectURL(file);
              this.contentSecondary = fileurl;
            } else {
              this.contentSecondary = response.data;
            }
            this.$nextTick(() => {
              const styleTags = document
                .getElementById("actContentSecondary")
                .querySelectorAll("style");
              styleTags.forEach((styleTag) => {
                styleTag.innerHTML =
                  "#actContentSecondary" + styleTag.innerHTML;
                styleTag.innerHTML = styleTag.innerHTML.replace(
                  /}/g,
                  "} #actContentSecondary"
                );
              });
              this.secondaryLinkLoaded();
            });
          })
          .catch((err) => {
            console.log(err);
            if (!this.userInfoState) {
              this.closeSecondary();
              this.$root.$emit("bv::show::modal", "login-modal", "#btnShow");
            }
          });
      }
    },
    textSearch(newValue) {
      window
        .$("#actContentPrimaryScroll")
        .unhighlight({ className: "pronadjen" });
      if (newValue !== null && newValue.length > 0) {
        window
          .$("#actContentPrimaryScroll")
          .highlight(newValue, { className: "pronadjen" });
      }
      this.scrollIndex = 0;
    },
    textSearchSecondary(newValue) {
      window.$("#actContentSecondary").unhighlight({ className: "pronadjen" });
      if (newValue !== null && newValue.length > 0) {
        window
          .$("#actContentSecondary")
          .highlight(newValue, { className: "pronadjen" });
      }
      this.scrollIndexSecondary = 0;
    },
  },
  methods: {
    openActIdCard() {
      let self = this;
      this.contentSecondary = null;
      this.secondaryType = "actIdCard";
      this.textSearchSecondary = null;
      this.contentSecondaryLink =
        self.baseRegulationsApiUrl + "actIdCard?actId=" + self.act.id;
    },
    openActNavigation() {
      this.secondaryType = "actNavigation";
      this.contentSecondaryLink =
        "viewdoc?uuid=" +
        this.act.url +
        "&regulationsActId=" +
        this.act.id.toString() +
        "&doctype=regulations&applyStyles=false";
    },
    openGroupActs() {
      let self = this;
      this.showSecondary = false;
      this.contentSecondaryLink = null;
      this.textSearchSecondary = null;
      axios
        .get(
          this.baseRegulationsApiUrl +
            "GetSubareaTree?subareaId=" +
            this.act.areaId +
            "&pu=" +
            this.act.hm
        )
        .then(function(content) {
          self.contentSecondary = content.data;
          self.secondaryType = "groupActs";
        });
    },
    openGroupAct(actId) {
      this.showSecondary = false;
      this.secondaryType = null;
      this.contentSecondary = null;
      this.textSearchSecondary = null;
      this.contentSecondaryLink =
        "viewdoc?regulationsActId=" + actId.toString() + "&doctype=regulations";
    },
    openPreviousVersion(uuid, actId) {
      this.showSecondary = false;
      this.textSearchSecondary = null;
      this.secondaryType = "previousVersion";
      this.contentSecondaryLink =
        "viewdoc?uuid=" +
        uuid +
        "&regulationsActId=" +
        actId.toString() +
        "&doctype=regulations&applyStyles=false";
    },
    openInlineUrl(url) {
      this.showSecondary = false;
      this.textSearchSecondary = null;
      this.secondaryType = "fullLink";
      this.contentSecondaryLink = url;
    },
    openHtmlLink(uuid) {
      this.showSecondary = false;
      this.textSearchSecondary = null;
      this.secondaryType = "slglLink";
      this.contentSecondaryLink = "prins/viewdoc?uuid=" + uuid;
    },
    openInNewTab(link) {
      window.open(link, "_blank");
    },
    toggleShowChanges() {
      this.showChanges = !this.showChanges;
    },
    toggleActAbstract() {
      if (window.$("#actAbstract").hasClass("hidden")) {
        window.$("#actAbstract").removeClass("hidden");
        window
          .$("#actAbstractToggle span")
          .removeClass("fa-angle-down")
          .addClass("fa-angle-up");
        window.$("#actAbstractToggle").addClass("active");
      } else {
        window.$("#actAbstract").addClass("hidden");
        window
          .$("#actAbstractToggle span")
          .removeClass("fa-angle-up")
          .addClass("fa-angle-down");
        window.$("#actAbstractToggle").removeClass("active");
      }
    },
    onPrintClick() {
      axios
        .get(
          this.baseRegulationsApiUrl +
            "viewdoc?uuid=" +
            this.act.url +
            "&regulationsActId=" +
            this.act.id.toString() +
            "&doctype=regulations"
        )
        .then((response) => {
          var tab = window.open("", "_blank");
          tab.document.write(response.data); // where 'html' is a variable containing your HTML
          tab.document.close();
          setTimeout(() => {
            tab.print();
            tab.close();
          }, 100);
        });
    },
    async onPrintSecondaryClick() {
      if (
        this.secondaryType === "actNavigation" ||
        this.secondaryType === "groupActs" ||
        this.secondaryType === "previousVersion" ||
        this.secondaryType === "fullLink" ||
        this.secondaryType === "relatedHtmlActLink"
      ) {
        var printContents = window.$("#actContentSecondary").html();
        if (
          this.secondaryType === "actNavigation" ||
          this.secondaryType === "previousVersion" ||
          this.secondaryType === "fullLink"
        )
          printContents = printContents.replace(
            /glasnik.css/,
            this.baseRegulationsApiUrl + "glasnik.css"
          );
        var popupWin = window.open("", "_blank");
        popupWin.document.open();
        if (typeof printContents !== "undefined") {
          popupWin.document.write(
            '<html><head><link rel="stylesheet" type="text/css" href="' +
              this.baseRegulationsApiUrl +
              'glasnik.css"></head><body onload="window.print(); window.close();">' +
              printContents +
              "</body></html>"
          );
        }
        popupWin.document.close();
      } else {
        var urlForPrint = this.contentSecondaryLink.replace(
          /applyStyles=false/,
          "applyStyles=true"
        );
        await axios.get(urlForPrint).then((response) => {
          var tab = window.open("", "_blank");
          tab.document.write(response.data); // where 'html' is a variable containing your HTML
          tab.document.close();
          setTimeout(() => {
            tab.print();
            tab.close();
          }, 100);
        });
      }
    },
    onNextClick() {
      var items = window.$("#actContentPrimaryScroll").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndex++;
        if (this.scrollIndex > items.length) {
          this.scrollIndex = 0;
        }
        items[this.scrollIndex].scrollIntoView();
      }
    },
    onPreviousClick() {
      var items = window.$("#actContentPrimaryScroll").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndex--;
        if (this.scrollIndex < 0) {
          this.scrollIndex = items.length;
        }
        if (items.length > 0) {
          items[this.scrollIndex].scrollIntoView();
        }
      }
    },
    onNextClickSecondary() {
      if (this.secondaryType === "actNavigation")
        var items = window
          .$("#actContentSecondary")
          .find(".force-display-block")
          .find(".pronadjen");
      else items = window.$("#actContentSecondary").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndexSecondary++;
        if (this.scrollIndexSecondary > items.length) {
          this.scrollIndexSecondary = 0;
        }

        const container = document.getElementById("actContentSecondaryScroll");
        const element = items[this.scrollIndexSecondary];

        if (container && element) {
          const elementPosition = element.offsetTop - container.offsetTop;
          container.scrollTop = elementPosition;
        }
        // items[this.scrollIndexSecondary].scrollIntoView();
      }
    },
    onPreviousClickSecondary() {
      if (this.secondaryType === "actNavigation")
        var items = window
          .$("#actContentSecondary")
          .find(".force-display-block")
          .find(".pronadjen");
      else items = window.$("#actContentSecondary").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndexSecondary--;
        if (this.scrollIndexSecondary < 0) {
          this.scrollIndexSecondary = items.length;
        }
        if (items.length > 0) {
          const container = document.getElementById(
            "actContentSecondaryScroll"
          );
          const element = items[this.scrollIndexSecondary];
          if (container && element) {
            const elementPosition = element.offsetTop - container.offsetTop;
            container.scrollTop = elementPosition;
          }
          //items[this.scrollIndexSecondary].scrollIntoView();
        }
      }
    },
    primaryKeyUp(event) {
      if (event.keyCode === 13) {
        this.onNextClick();
      }
    },
    secondaryKeyUp(event) {
      if (event.keyCode === 13) {
        this.onNextClickSecondary();
      }
    },
    async onDocxExportClick() {
      const lawActId = this.act.id;
      const lawActName = this.act.title;

      axios
        .get(
          this.baseRegulationsApiUrl +
            "GeneratePrimaryWordDocument?lawActId=" +
            lawActId,
          { responseType: "blob" }
        )
        .then(function(response) {
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download = lawActName + ".docx";
          link.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    onOnlyActContentClick() {
      window.open(
        this.baseRegulationsApiUrl +
          "viewdoc?uuid=" +
          this.act.url +
          "&regulationsActId=" +
          this.act.id.toString() +
          "&doctype=regulations",
        "_blank"
      );
    },
    closeSecondary() {
      this.showSecondary = true;
      this.contentSecondary = null;
      this.textSearchSecondary = null;
      this.secondaryType = null;
      this.contentSecondaryLink = null;
      this.relatedActsView = null;
    },
    exportSecondary() {
      var data = {
        lawActId: this.act.id,
        lawActCardHtml: this.contentSecondary,
      };
      const lawActName = this.act.title;

      axios
        .post(
          this.baseRegulationsApiUrl + "GenerateSecondaryWordDocument",
          data,
          {
            responseType: "blob",
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then(function(response) {
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download = "ЛК закона - " + lawActName + ".docx";
          link.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    secondaryLinkLoaded() {
      if (this.secondaryType === "actNavigation") {
        window
          .$("#actContentSecondary")
          .addClass("state-menu")
          .addClass("state-changes");
        this.navigationElements = window
          .$("#actContentSecondary")
          .find(
            '.act-menu-item,.odluka-zakon,.naslov,.clan,.bold,.italik,[class^="v2-odluka-zakon-"],' +
              '[class^="v2-naslov-"],[class^="v2-bold-verzal-"],[class^="v2-italik-verzal-"],[class^="v2-clan-verzal-"],' +
              '[class^="v2-bold-"],[class^="v2-italik-"],' +
              '.v2-underline,[class^="v2-spacija-"],[class^="v2-clan-"]'
          )
          .not('[class^="v2-clan-left"]')
          .not('[class^="v2-spacija-left-"]')
          .not('[class^="v2-italik-left-"]')
          .not('[class^="v2-bold-left-"]');
        this.originalNavigationElements = window
          .$("#actContentPrimaryScroll")
          .find(
            '.act-menu-item,.odluka-zakon,.naslov,.clan,.bold,.italik,[class^="v2-odluka-zakon-"],' +
              '[class^="v2-naslov-"],[class^="v2-bold-verzal-"],[class^="v2-italik-verzal-"],[class^="v2-clan-verzal-"],' +
              '[class^="v2-bold-"],[class^="v2-italik-"],' +
              '.v2-underline,[class^="v2-spacija-"],[class^="v2-clan-"]'
          )
          .not('[class^="v2-clan-left"]')
          .not('[class^="v2-spacija-left-"]')
          .not('[class^="v2-italik-left-"]')
          .not('[class^="v2-bold-left-"]');
        var el = null;
        var i = 0;
        for (i = 0; i < this.navigationElements.length; i++) {
          el = window.$(this.navigationElements[i]);
          el.parents().addClass("force-display-block");
          el.parent()
            .children()
            .addClass("force-display-none");
        }
        for (i = 0; i < this.navigationElements.length; i++) {
          el = window.$(this.navigationElements[i]);
          el.removeClass("force-display-none");
          el.addClass("force-display-block");
          el.children().addClass("force-display-block");
          el.on("click", { index: i }, this.onNavigationItemClicked);
        }
        // Pretraga po drugom clanu je sa latinicnim karakterom "a"
        window
          .$("#actContentSecondary")
          .find(
            '.clan:contains("Члан"),.clan:contains("Члaн"),' +
              '.v2-underline:contains("Члан"),.naslov,.italik,[class^="v2-italik-"]:contains("Члан"),' +
              '[class^="v2-clan-"]:contains("Члан"),[class^="v2-clan-"]:contains("Члaн")'
          )
          .not('[class^="v2-clan-left"]')
          .not('[class^="v2-clan-verzal"]')
          .addClass("clan-margin");
        window
          .$("#actContentSecondary")
          .find("p.force-display-block")
          .find(".force-display-block")
          .removeClass("force-display-block")
          .addClass("force-display-inline");
        window.$("#actContentSecondary").removeClass("force-display-block");
      }
    },
    onNavigationItemClicked(event) {
      // if (!window.$("#panelActIdCard").is(":visible")) {
      //   setTimeout(() => {
      //     this.closeSecondary();
      //     setTimeout(() => {
      //       this.originalNavigationElements[event.data.index].scrollIntoView();
      //     }, 100);
      //   });
      // } else {
      setTimeout(() => {
        this.originalNavigationElements[event.data.index].scrollIntoView();
      }, 100);
      // }
    },
    async getArticleReferenceBases() {
      var data = {
        LawActName: this.regViewActBean.actView.title,
      };
      try {
        let response = await axios.post(
          `${this.baseDIApiUrl}REG/GetRelatedActsByArticles`,
          data
        );
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    getArticleDropdownItems(tabs, article) {
      return tabs
        .map((tab) => {
          let name = this.articleReferenceBases[tab];
          return `<button data-article-base="${tab}" data-article="${article}" class="dropdown-item open-related-acts" >${name}</button>`;
        })
        .join("");
    },
    handleArticleClick(event) {
      const target = event.target;
      if (
        target.tagName === "A" &&
        (target.classList.contains("subtreeLink") ||
          target.classList.contains("idcard-link"))
      ) {
        const dataCustomValue = target.getAttribute("data-click");
        this.openInlineUrl(dataCustomValue);
      } else if (
        target.tagName === "BUTTON" &&
        target.classList.contains("open-related-acts")
      ) {
        const dataArticle = target.getAttribute("data-article");
        const dataArticleBase = target.getAttribute("data-article-base");
        this.openArticleRelatedActs(dataArticle, dataArticleBase);
      }
    },
    openArticleRelatedActs(dataArticle, dataArticleBase) {
      var data = {
        LawActName: this.regViewActBean.actView.title,
        LawActArticle: dataArticle,
      };
      axios
        .post(
          `${this.baseDIApiUrl}${dataArticleBase}/GetRelatedActsByActNameAndArticle`,
          data
        )
        .then((response) => {
          this.contentSecondaryLink = null;
          this.relatedActsView = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    handleRelatedActClick(link, contentType) {
      this.secondaryType =
        contentType === "pdf" ? "relatedPdfActLink" : "relatedHtmlActLink";
      this.contentSecondaryLink = link;
    },
  },
  computed: {
    ...mapState(["userInfoState"]),
    articleReferenceBases() {
      return {
        mml: "Мишљења, модели и литература",
        sp: "Судска пракса",
      };
    },
    regViewActBean() {
      return {
        actView: this.act,
        wpp: false,
      };
    },
    filteredReferences() {
      return Object.keys(this.references).filter(
        (key) => this.references[key] !== null
      );
    },
    wpp() {
      return this.regViewActBean.wpp;
    },
    contentPrimaryLink() {
      return (
        this.baseRegulationsApiUrl +
        "viewdoc?uuid=" +
        this.act.url +
        "&regulationsActId=" +
        this.act.id.toString() +
        "&doctype=regulations"
      );
    },
  },
  async mounted() {
    var self = this;
    //GetLawActViewByGuid - ukoliko imamo guid i idemo iz pretrage
    if (this.$route.params.actId) {
      this.actGuid = this.$route.params.actId;
    }
    await axios
      .get(
        this.baseRegulationsApiUrl +
          "GetLawActViewByGuid?guid=" +
          this.$route.params.actId
      )
      .then((response) => {
        if (response.data.pdfBytes) {
          var binaryString = window.atob(response.data.pdfBytes);
          var binaryLength = binaryString.length;
          var bytes = new Uint8Array(binaryLength);
          for (var i = 0; i < binaryLength; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
          }
          var blob = new Blob([bytes], { type: "application/pdf" });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          var fileName = response.data.title;
          link.download = `${fileName}.pdf`;
          link.click();
        }
        this.actGuid = response.data.hm;
        this.act = response.data;
        this.actTitle = response.data.title;
        this.searchQuery = response.data.baseTitle;
        this.versionGuid = response.data.versionGuid;
        this.implementsActNavigation = response.data.ssl;

        this.act.id &&
          axios
            .get(
              this.baseRegulationsApiUrl +
                "GetGlobalActReferencesByLawActId?lawActId=" +
                this.act.id
            )
            .then((res) => {
              this.references = res.data;
              this.$nextTick(() => {
                var referenceHeaders = document.querySelectorAll(
                  ".reference-list h5"
                );
                referenceHeaders.forEach(function(header) {
                  header.addEventListener("click", function() {
                    var parent = this.parentNode;
                    parent.classList.toggle("expanded");

                    var spans = parent.querySelectorAll("span");
                    spans.forEach(function(span) {
                      if (parent.classList.contains("expanded")) {
                        span.classList.remove("fa-plus-square");
                        span.classList.add("fa-minus-square");
                      } else {
                        span.classList.remove("fa-minus-square");
                        span.classList.add("fa-plus-square");
                      }
                    });
                  });
                });

                var dropdownToggles = document.querySelectorAll(
                  ".dropdown .dropdown-toggle"
                );

                dropdownToggles.forEach(function(toggle) {
                  toggle.addEventListener("click", function() {
                    var parent = this.parentNode;
                    var hasClass = parent.classList.contains("open");

                    var allDropdowns = document.querySelectorAll(".dropdown");
                    allDropdowns.forEach(function(dropdown) {
                      dropdown.classList.remove("open");
                    });

                    if (!hasClass) {
                      parent.classList.toggle("open");
                    }
                  });
                });
              });
            });
        if (this.act.hm && this.act.areaId)
          axios
            .get(
              this.baseRegulationsApiUrl +
                "HasChildActs?subareaId=" +
                this.act.areaId +
                "&pu=" +
                this.act.hm
            )
            .then((response) => {
              self.showGroupActs = response.data;
            });
      })
      .catch((error) => {
        if (error.response.status === 401)
         window.location.href = '/'
      });

    if (this.actGuid)
      await axios
        .get(
          this.baseRegulationsApiUrl +
            "viewAct/" +
            this.actGuid +
            "?lawActId=" +
            self.act.id
        )
        .then((response) => {
          this.contentPrimary = response.data;

          this.$nextTick(() => {
            const styleTags = document
              .getElementById("primaryContentHtml")
              .querySelectorAll("style");
            styleTags.forEach((styleTag) => {
              styleTag.innerHTML = "#primaryContentHtml" + styleTag.innerHTML;
              styleTag.innerHTML = styleTag.innerHTML.replace(
                /}/g,
                "} #primaryContentHtml"
              );
            });
            window.$("#primaryContentHtml").on("click auxclick", function(e) {
              if (
                e.target.nodeName === "A" ||
                e.target.parentElement.nodeName === "A"
              ) {
                if (e.target.nodeName === "A") {
                  if (e.target.href.includes("/viewdoc"))
                    e.target.href = e.target.href.substr(
                      e.target.href.indexOf("/viewdoc")
                    );
                  if (e.target.href.includes("/eli"))
                    var startIndex = e.target.href.indexOf("/eli");
                  var prefix = e.target.href.substring(0, startIndex);

                  //ukoliko imamo eli u linku, sklonicemo njega, i otvoreni link ce imati samo extref
                  if (e.target.href.includes("/extref")) {
                    var endIndex = e.target.href.indexOf("/extref");
                    var suffix = e.target.href.substring(endIndex);
                    if (startIndex !== -1 && endIndex !== -1)
                      e.target.href = prefix + suffix;
                  } else {
                    e.target.href = prefix;
                  }
                }
              }
            });
          });
        })
        .catch((error) => {
          document.write(error.message);
        });
  },
  beforeCreate: function() {
    document.body.className = "color_regulations view-act-page";
  },
  components: { HtmlDiv, RelatedActsView, PDFJSViewer },
};
</script>

<style scoped>
@import "~@fortawesome/fontawesome-free/css/all.css";

.container-slgl {
  padding-left: 15px;
  padding-right: 15px;
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
}

.view-act-primary {
  overflow: auto !important;
  padding: 5px;
  border-top: 2px solid #cccccc;
  height: -webkit-calc(100% - 81px);
  height: -moz-calc(100% - 81px);
  height: -o-calc(100% - 81px);
  height: calc(100% - 81px);
}

@media (max-width: 1200px) {
  .container-slgl {
    overflow: unset !important;
  }
}

.highlighted {
  background: #ff0;
}

.row {
  margin-right: 0px !important;
  margin-left: 0px !important;
}

.view-act-primary {
  width: 100%;
}

@media (max-width: 990px) {
  #actContentPrimaryScroll {
    margin-bottom: 40px;
  }
}

#actTitleNavbar {
  width: 100% !important;
  display: block !important;
  padding: 0;
}

#actTitleNavbar #actTitle {
  padding: 10px !important;
  font-size: 20px !important;
}

.top-line__item a:hover {
  text-decoration: none !important;
}

/* section.base-header-sec {
    height: 0 !important;
  }
  
  .base-header__top-line.laen {
    display: none !important;
  } */

.theme-green.main-panel {
  display: block;
}

@media (min-width: 1200px) {
  .col-lg-offset-2 {
    margin-left: 16.66666667%;
  }
}

#actContentPrimaryScroll {
  height: calc(100vh - 235px) !important;
  top: 41px !important;
  border-top: 2px solid #cccccc;
}

.flex-div {
  display: flex !important;
}

.p-left {
  padding-left: 15px;
}

.theme-green .panel-heading,
#actTitle {
  background: linear-gradient(to bottom, #579681 0%, #376f5c 100%) !important;
  padding: 10px 15px;
}

.panel.panel-default:not(:first-child) {
  margin: 5px 0 0 0;
}

.panel-title.panel-title {
  margin: 0;
}

.panel-heading {
  border-radius: 4px 4px 0 0;
}

#searchBarPrimary,
.secondary-frame-parent {
  padding: 2px;
}

.left-search .btn-default:hover,
.right-search .btn-default:hover,
#searchBarPrimary .btn-default:hover {
  color: #333;
  background-color: #e6e6e6 !important;
  border-color: #adadad !important;
}

#searchBarPrimary .left-search .btn-default,
.secondary-frame-parent .left-search .btn-default {
  background-color: #fff;
  box-shadow: none;
  border-radius: 0;
  border-right: 1px solid #ccc !important;
  border-top: 1px solid #ccc !important;
  border-bottom: 1px solid #ccc !important;
  height: 38px;
}

#searchBarPrimary .left-search,
.secondary-frame-parent .left-search {
  border: none;
}

#searchBarPrimary .left-search .btn-default:first-child,
.secondary-frame-parent .left-search .btn-default:first-child {
  border-radius: 4px 0 0 4px;
  border: 1px solid #ccc !important;
}

#searchBarPrimary .left-search .btn-default:last-child,
.secondary-frame-parent .left-search .btn-default:last-child {
  border-right: none !important;
  background-color: #fff;
}

.color_regulations .site-header .navbar-pis .nav-link:before,
.color_regulations .base-header__top-line {
  background: linear-gradient(103deg, #e14356 0%, white 100%) !important;
}

#searchBarPrimary .right-search,
.secondary-frame-parent .right-search {
  border-left: none !important;
  border-right: none !important;
}

#searchBarPrimary .right-search .btn-default,
.secondary-frame-parent .right-search .btn-default {
  border-left: none !important;
  border-radius: 0 4px 4px 0 !important;
  background-color: #fff;
  height: 36px;
}

.secondary-frame-parent .input-group-btn.previous-solo-btn .btn-default {
  background-color: #fff !important;
  height: 36px !important;
  box-shadow: none !important;
}

.secondary-frame-parent .input-group-btn.previous-solo-btn {
  border-right: none !important;
  border-left: none !important;
}

.secondary-frame-parent .input-group-btn.left-search {
  border-top: none !important;
}

#actContentSecondaryScroll {
  height: calc(100vh - 235px) !important;
  background-color: #fff;
  border-top: 3px solid #ddd !important;
  padding: 16px;
  overflow-x: hidden !important;
}

.panel.panel-default ul {
  list-style: none;
}

/* .panel.panel-default ul li {
    font-size: 12px;
  } */

.panel.panel-default ul a:hover {
  text-decoration: underline !important;
}

.panel.panel-default h5 {
  /* font-size: 75%; */
  cursor: pointer;
}

.panel.panel-default {
  background-color: #fff !important;
  border-radius: 0 0 4px 4px;
  border: 1px solid #ddd !important;
}

.reference-list ul {
  display: none;
}

.reference-list.expanded ul {
  display: block;
}

.panel-collapse.collapse {
  max-height: 450px;
  overflow: auto;
}

#actContentSecondaryScroll {
  position: relative;
}

.nav-buttons-act {
  background-color: #f8f8f8;
  padding-left: 15px;
}

.nav-buttons-act ul a {
  color: #333;
  font-size: 75%;
  padding: 15px;
  display: block;
  background-color: #fff;
  border-right: 1px solid #ddd;
}

.navbar-nav {
  flex-direction: row !important;
}

.collapse.show {
  display: block !important;
}

.reference-list a {
  cursor: pointer;
  color: #333333 !important;
}

.reference-list ul li {
  padding-bottom: 6px;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 2px;
  padding-left: 6px;
  line-height: 90%;
}

.reference-list h5 {
  cursor: pointer;
  margin: 0;
  padding: 12px;
  font-size: 75%;
}

.reference-list a {
  font-size: 70%;
  cursor: pointer;
  color: #333333 !important;
}

.act-idcard-value-cell-1 p a {
  color: #337ab7 !important;
}

@media (min-width: 768px) {
  .expand-tabs-sm {
    display: none;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  #navbar-header-collapse {
    display: block;
  }
}

@media (min-width: 991px) {
  #navbar-header-collapse {
    display: none !important;
  }
}

.dropdown a:first-child {
  background-color: transparent !important;
  border-right: none !important;
}

.dropdown.open > a:first-child {
  background-color: #e7e7e7 !important;
}

.dropdown.open .dropdown-menu {
  display: block;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
}

.dropdown.open .dropdown-menu .reference-list a {
  padding: 0 !important;
}

.dropdown.open .dropdown-menu a {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.dropdown.open .dropdown-menu ul {
  list-style: none;
  padding-left: 16px;
}

#searchBarPrimary input.form-control::placeholder,
.secondary-frame-parent input.form-control::placeholder {
  color: #a69999 !important;
  font-size: 100% !important;
}

#searchBarPrimary input.form-control,
.secondary-frame-parent input.form-control {
  font-size: 88% !important;
  height: 38px;
}

@media (min-width: 991px) {
  .navbar-nav.hidden-md {
    display: none;
  }
}

@media (max-width: 991px) {
  .hidden-small-collapse {
    display: none !important;
  }
}

@media (max-width: 768px) {
  .navbar-nav.hidden-md li {
    width: 100%;
    display: block;
  }
}

.navigation-menu {
  background: #ffffff !important;
  background-color: #ffffff !important;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border: 0 !important;
  padding: 5px 0 !important;
  margin: 2px 0 0 !important;
}
</style>
